import React from 'react'
import styles from './styles.module.css'

const Loading = ({ children, title, ...props }) => {
	return (
		<div {...props}>
			<div>
				<div className={`${styles.pulse} mx-auto flex justify-center items-center`}>
					{children}
				</div>
			</div>
			<h2 className="text-xl lg:text-4xl font-bold text-center mt-20">{title}</h2>
		</div>
	)
}

export default Loading